// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sxvrqshcqmbmogkwcixe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4dnJxc2hjcW1ibW9na3djaXhlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ1OTkxMDgsImV4cCI6MjA3MDE3NTEwOH0.7JBrBWyheGF7yJg5dEzGlyEN9EdtO4kyDiZBuwmFRps";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});